<template>
  <div class="rt-label-group">
    <el-checkbox-group
      v-model="selectValue"
      v-bind="$attrs"
      @change="handelChange"
    >
      <slot>
        <rt-label-item
          v-for="(item, index) in labelList"
          :key="index"
          :label="item[valueKey]"
        >
          <span>{{ item[nameKey] }}</span>
          <img
            src="../../assets/imgs/check-circle-fill.png"
            alt=""
          />
        </rt-label-item>
      </slot>
    </el-checkbox-group>
  </div>
</template>
<script>
import RtLabelItem from '../label/rtLabelItem.vue';
export default {
  name: 'RtLabelGroup',
  components: { RtLabelItem },
  props: {
    value: Array,
    labelList: {
      type: Array,
      default: () => {
        return [];
      }
    },
    alias: {
      type: Object,
      default: () => {
        return {
          valueKey: 'value',
          nameKey: 'name'
        };
      }
    }
  },
  data () {
    return {
      selectValue: this.value
    };
  },
  computed: {
    valueKey () {
      return this.alias.valueKey;
    },
    nameKey () {
      return this.alias.nameKey;
    }
  },
  watch: {
    value (newVal, oldVal) {
      this.selectValue = newVal;
    }
  },
  methods: {
    handelChange (val) {
      this.$emit('input', val);
    }
  }
};
</script>



// WEBPACK FOOTER //
// rtLabelGroup.vue?881ad35c